<template>
	<div id="reminderRisk">
		<div class="subscriptionsBootom">
			【免责声明】龙虎榜基础数据来源于第三方，本公司尽力但不保证相关数据的真实性、准确性、完整性、及时性与有效性。内容仅供参考，不构成投资建议。 本公司不承担因任何数据准确，遗漏等造成的任何损失或损害的责任。投资者依据相关信息进行投资操作时，应当自主做出判断。所导致的盈亏由投资者自行承担，股市有风险，投资需谨慎！
		</div>
	</div>
</template>

<script>
export default {
	name: 'reminderRisk'
}
</script>

<style scoped>
.subscriptionsBootom {
	width: 100%;
	box-sizing: border-box;
	font-size: .12rem;
	line-height: .19rem;
	color: #999;
	padding: .24rem .28rem 0.46rem .15rem;
}
</style>


// WEBPACK FOOTER //
// src/common/reminderRisk.vue